export default __webpack_public_path__ + "static/media/img-flip-h.78a440e3.svg";